module.exports = __webpack_public_path__ + "img/feather-pointed.fa0baf83.svg";